export const navManager = {
  initial: 'idle',
  states: {
    idle: {
      on: {
        LAYOUT_PAGEID_CHANGE: 'updateNavComponents',
        LAYOUT_CHANGE_END: 'updateNavComponents',
        LAYOUT_SIDEBAR_CLOSE: 'updateNavComponents',
      },
    },
    updateNavComponents: {
      always: {
        target: 'idle',
        actions: [
          {
            type: 'batchLayoutOperations',
            data: [
              {
                type: 'setLayoutProperty',
                data: {
                  path:
                    'components.BottomNavigation.properties.currentPagePath',
                  value: '$event.mainLayoutPath',
                },
                meta: {
                  selectors: ['$action.data.value'],
                },
              },
              {
                type: 'setLayoutProperty',
                data: {
                  path:
                    'components.StaticNavigation.properties.currentPagePath',
                  value: '$event.mainLayoutPath',
                },
                meta: {
                  selectors: ['$action.data.value'],
                },
              },
            ],
          },
        ],
      },
    },
  },
};
